import { APP_BASE_HREF, CommonModule, DatePipe, PlatformLocation } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import {
    FeedbackEmailButtonModule,
    FeedbackModule,
    StartOverButtonModule,
    StartOverModule,
    TrademeCoreUiModule
} from '@classifieds-sell/trademe-core-ui';
import {
    TgBoxes2Module,
    TgButtons2Module,
    TgGridModule,
    TgIconBasicArrowRightModule,
    TgIconBasicInfoFramedModule,
    TgIconBasicTickFramedModule,
    TgIconBasicWarningFramedModule,
    TgIconStopModule, TgLoadingModule, TgModalModule,
    TgRackModule,
    TgSvgModule
} from '@trademe/tangram';
import { MotorsFooterComponent } from './components/motors-footer/motors-footer.component';
import { MotorsHeaderComponent } from './components/motors-header/motors-header.component';
import { MotorsHomeComponent } from './components/motors-home/motors-home.component';
import { MotorsLandingComponent } from './components/motors-landing/motors-landing.component';
import { MotorsTabsComponent } from './components/motors-tabs/motors-tabs.component';
import { MotorsUiRouteModule } from './motors-ui-routes';
import { BoatsAndMarineDescriptionAndPhotosPageModule } from './pages/category-page-overrides/boats-and-marine/description-and-photos/motors-description-and-photos-page.module';
import { BoatsAndMarineListingDetailsPageModule } from './pages/category-page-overrides/boats-and-marine/listing-details/motors-listing-details-page.module';
import { BoatsAndMarineSummaryPageModule } from './pages/category-page-overrides/boats-and-marine/summary/motors-summary-page.module';
import { BoatsAndMarineVehicleDetailsPageModule } from './pages/category-page-overrides/boats-and-marine/vehicle-details/motors-vehicle-details-page.module';
import { InitService } from './services/init-service';
import {
  MotorsDraftEffects,
  MotorsDraftFacade, PingEffects,
  RouterEffects,
  RouterFacade,
  UserEffects,
  UserFacade
} from '@classifieds-sell/state';
import * as fromUser from '@classifieds-sell/state';
import * as fromDraft from '@classifieds-sell/state';
import * as fromRouter from '@classifieds-sell/state';
import { MotorsIllustrationBoatModule } from './components/motors-illustration-boat/motors-illustration-boat.module';
import {
  FormHelperService,
  RouterService,
  RouterToStoreLinkService,
  TmInterceptor,
  TMStepIndicatorModule
} from '@classifieds-sell/shared';
import { CreditAccountModule } from './credit-account/credit-account.module';
import * as fromPing from '@classifieds-sell/state';
import { FeeCalculationFacade } from './state/fee-calculation/fee-calculation.facade';
import { AnalyticsService } from './services/analytics-service';
import { MotorsMaintenanceComponent } from './components/motors-maintenance/motors-maintenance.component';

const COMPONENTS = [
  MotorsHeaderComponent,
  MotorsHomeComponent,
  MotorsLandingComponent,
  MotorsTabsComponent,
  MotorsFooterComponent,
  MotorsMaintenanceComponent
];

@NgModule({
    imports: [
        CommonModule,
        CreditAccountModule,
        EffectsModule.forFeature([MotorsDraftEffects]),
        EffectsModule.forFeature([PingEffects]),
        EffectsModule.forFeature([RouterEffects]),
        EffectsModule.forFeature([UserEffects]),
        MotorsUiRouteModule,
        TrademeCoreUiModule,
        FeedbackModule,
        FeedbackEmailButtonModule,
        StartOverButtonModule,
        StartOverModule,
        StoreModule.forFeature(
          fromRouter.ROUTER_FEATURE_KEY,
          fromRouter.routerReducer
        ),
        StoreModule.forFeature(
          fromDraft.DRAFT_FEATURE_KEY,
          fromDraft.draftReducerFunc
        ),
        StoreModule.forFeature(
          fromDraft.DRAFT_MOTORS_FEATURE_KEY,
          fromDraft.draftReducerMotorsFunc
        ),
        StoreModule.forFeature(
          fromUser.USER_FEATURE_KEY,
          fromUser.userReducerFunc
        ),
        StoreModule.forFeature(
          fromPing.PING_FEATURE,
          fromPing.pingReducerFunc
        ),
        TMStepIndicatorModule,
        TgSvgModule,
        TgIconBasicArrowRightModule,
        TgIconStopModule,
        TgIconBasicTickFramedModule,
        TgIconBasicInfoFramedModule,
        TgIconBasicWarningFramedModule,
        TgModalModule,
        TgGridModule,
        TgRackModule,
        TgButtons2Module,
        TgLoadingModule,
        BoatsAndMarineVehicleDetailsPageModule,
        BoatsAndMarineListingDetailsPageModule,
        BoatsAndMarineDescriptionAndPhotosPageModule,
        BoatsAndMarineSummaryPageModule,
        MotorsIllustrationBoatModule,
        TgBoxes2Module
    ],
  declarations: [COMPONENTS],
  exports: [MotorsHeaderComponent],
  providers: [
      RouterFacade,
      RouterService,
      RouterToStoreLinkService,
      InitService,
      FormHelperService,
      provideAppInitializer(() => {
        const initializerFn = ((service: InitService) =>
            function () {
              return service.init();
            })(inject(InitService));
        return initializerFn();
      }),
      {
          provide: HTTP_INTERCEPTORS,
          useClass: TmInterceptor,
          multi: true
      },
      {
          provide: APP_BASE_HREF,
          useFactory: (s: PlatformLocation) => s.getBaseHrefFromDOM(),
          deps: [PlatformLocation]
      },
      MotorsDraftFacade,
      UserFacade,
      DatePipe,
      AnalyticsService,
      FeeCalculationFacade
  ]
})
export class MotorsUiModule { }
